import { gsap } from 'gsap'
import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.items = [...this.el.querySelectorAll('.o-story_carousel_render_item')]
    this.legends = [...this.el.querySelectorAll('.o-story_block_legend')]

    this.progress = this.el.querySelector('.o-story_carousel_progress')

    this.currentIndex = null
    this.maxIndex = this.items.length - 1

    this.interval = null
    this.duration = 8
    this.progressAnim = null

    this.events = { click: { activateItem: 'activateItem' } }
  }

  playProgress() {
    this.progressAnim = gsap.fromTo(
      this.progress,
      { scaleX: 0 },
      {
        scaleX: 1,
        ease: 'none',
        duration: this.duration,
        onComplete: () => {
          const newIndex = this.currentIndex === this.maxIndex
            ? 0
            : this.currentIndex + 1

          this.showItem(newIndex)
        }
      }
    )
  }

  resetProgress() {
    gsap.to(this.progress, {
      scaleX: 0,
      ease: 'expo.out',
      duration: 0.4
    })
  }

  showItem(index) {
    // If current is already active
    if (this.currentIndex === index) {
      return
    }

    const oldItem = this.items[this.currentIndex]
    const oldLegend = this.legends[this.currentIndex]

    if (oldItem) {
      oldItem.classList.remove('-active')
      oldLegend.classList.remove('-active')
      this.pauseMedia(oldItem)
    }

    this.currentIndex = index

    if (this.maxIndex > 0) {
      this.playProgress(index)
    }

    const newItem = this.items[this.currentIndex]
    const newLegend = this.legends[this.currentIndex]

    newItem.classList.add('-active')
    newLegend.classList.add('-active')

    this.playMedia(newItem)
  }

  playMedia(mediaWrap) {
    if (mediaWrap.querySelector('video')) {
      mediaWrap.querySelector('video').play()
    }
  }

  pauseMedia(mediaWrap) {
    if (mediaWrap.querySelector('video')) {
      mediaWrap.querySelector('video').pause()
    }
  }

  activateItem(e) {
    const target = e.currentTarget
    const index = Number.parseInt(target.getAttribute('data-index'))

    if (index === this.currentIndex)
      return

    this.progressAnim.pause()
    this.showItem(index)
  }

  toggle(e) {
    if (e.way === 'enter') {
      if (this.progressAnim) {
        this.progressAnim.play()
      }
      else {
        this.showItem(0)
      }
    }
    else {
      if (this.progressAnim) {
        this.progressAnim.pause()
        this.pauseMedia(this.items[this.currentIndex])
      }
    }
  }
}
